import { useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom'
import { selectCountry } from '../../../common/category/store/slice'
import useCompanyHeader from '../../../common/category/useCompanyHeader'
import { Element } from '../../../common/html/element'
import { DEFAULT_CODE } from '../../../layout/header/search/constants'
import { COMPANY_TYPES } from '../../../utils/common'
import { BlockBasicInfo } from './BlockBasicInfo'
import { BlockLocation } from './BlockLocation'
import { BlockTreeAge } from './BlockTreeAge'
import { BlockChart } from './blockChart'
import classes from './index.module.scss'

const DOMESTIC_ROUTE = '/domesticSearch'

export const PreviewCompanyInfo = ({ data }) => {
  const country = useSelector(selectCountry)
  const location = useLocation()

  const isDomesticRoute = location.pathname.includes(DOMESTIC_ROUTE)
  const isDomesticSearch =
    Object.keys(country) && country.code === DEFAULT_CODE && isDomesticRoute
  const { companyHeader } = useCompanyHeader({ disableCallApi: true })

  return (
    <>
      <Element
        className={classes.companyInfoContainer}
        style={{ borderColor: '#d5d5d5' }}
      >
        <BlockBasicInfo data={data} isDomesticSearch={isDomesticSearch} />
        <BlockTreeAge data={data} isDomesticSearch={isDomesticSearch} />
        {isDomesticSearch &&
          ![COMPANY_TYPES.FUNDS, COMPANY_TYPES.INSURANCE].includes(
            companyHeader?.companyType,
          ) && <BlockChart data={data} />}
      </Element>
      <BlockLocation data={data} isDomesticSearch={isDomesticSearch} />
    </>
  )
}
